import { render } from "./ExchangeCoupon.vue?vue&type=template&id=b3a65e30"
import script from "./ExchangeCoupon.vue?vue&type=script&lang=js"
export * from "./ExchangeCoupon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__